import React from "react";
import { Link } from "react-router-dom";
import { StatusBadge } from "./StatusBadge";
import { formatIDR, formatDate } from "../../lib/format";

/**
 * K212 / BUSINESS-83 + K214 / BUSINESS-87 — keadaan uang yang dikembalikan pemasok untuk SATU retur (penyelesaian
 * refund disetujui) atau SATU uang muka (ditagih balik). `uangKembali` = isian `uang_kembali` dari rincian backend;
 * null = bukan sumber uang kembali → tidak menampilkan apa pun. Finance mencatat tiap uang yang masuk di layar Uang
 * Masuk (boleh beberapa kali sampai jumlahnya terpenuhi); sisanya ditagih Admin Purchasing. K215 / BUSINESS-90: uang
 * yang masuk melebihi jumlah disepakati tetap dicatat; kelebihannya (`lebih_idr`) diselesaikan lewat panel uang lebih.
 */
export default function UangKembaliStatus({ uangKembali, testId = "uang-kembali-status" }) {
  if (!uangKembali) return null;
  const terima = uangKembali.penerimaan || [];
  const penuh = uangKembali.keadaan === "TERCATAT";
  return (
    <div className="text-sm space-y-1" data-testid={testId}>
      {penuh ? (
        <StatusBadge tone="success">Uang kembali diterima penuh {formatIDR(uangKembali.total_diterima_idr)}</StatusBadge>
      ) : terima.length ? (
        <StatusBadge tone="warning">
          Baru diterima {formatIDR(uangKembali.total_diterima_idr)} dari {formatIDR(uangKembali.nilai_diharapkan_idr)} · sisa {formatIDR(uangKembali.sisa_idr)}
        </StatusBadge>
      ) : (
        <StatusBadge tone="warning">Menunggu uang kembali {formatIDR(uangKembali.nilai_diharapkan_idr)}</StatusBadge>
      )}
      {Number(uangKembali.lebih_idr) > 0 && (
        <StatusBadge tone="warning">
          Uang lebih dari pemasok {formatIDR(uangKembali.lebih_idr)} — penyelesaiannya dipilih Admin Purchasing, disetujui Kepala Cabang
        </StatusBadge>
      )}
      {terima.length > 0 && (
        <ul className="text-xs text-muted-foreground space-y-0.5" data-testid={`${testId}-penerimaan`}>
          {terima.map((c) => (
            <li key={c.id}>
              {formatDate(c.tanggal_terima)} · {formatIDR(c.nominal_idr)}{c.catatan ? ` · ${c.catatan}` : ""}
            </li>
          ))}
        </ul>
      )}
      {!penuh && (
        <div className="text-xs text-muted-foreground">
          {terima.length ? "Sisanya ditagih Admin Purchasing ke pemasok. " : ""}
          Dicatat Finance di <Link to="/keuangan/uang-masuk" className="underline">Uang Masuk</Link> tiap kali uangnya
          masuk rekening (tanggal, nominal, bukti mutasi).
        </div>
      )}
    </div>
  );
}
